export default "__VITE_PUBLIC_ASSET__93f6ad41__"